interface ClearTimeout {
  (timeoutId?: number): void
}

interface Entries {
  <T extends PropertyKey, U>(object: { [K in T]?: U }): [string & T, U][]
  <T>(object: T): [keyof T & string, T[keyof T & string]][]
  (object: any): [string, any][]
}

interface Keys {
  <T extends PropertyKey, U>(object: { [K in T]?: U }): (string & T)[]
  <T>(object: T): (keyof T & string)[]
  (object: any): string[]
}

interface SetTimeout {
  (callback?: () => void, timeout?: number): number
}

interface Values {
  <T extends PropertyKey, U>(object: { [K in T]?: U }): U[]
  <T>(object: T): T[keyof T & string][]
  (object: any): any[]
}

export const keys = Object.keys as Keys
export const values = Object.values as Values
export const entries = Object.entries as Entries
export const setTimeout = globalThis.setTimeout as SetTimeout
export const clearTimeout = globalThis.clearTimeout as ClearTimeout
